import React from 'react';
import { Button }  from '@mui/material';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteDC } from '../../../Store/PHPSlice/Packing/PackApis';


const TableBody = ({
    serialNumber,
    id,
    firmNm,
    partyId,
    pkMemo,
    partyNm,
    transport,
    billNo,
    dt,
    spId,
    totqty,
    sts,
    total_amt,
    net_amt,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        // window.open(`/packing-edit/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    const userId = '1';
      const handleInvoiceBill = () => {
        window.open(`/invoice-bill/${spId}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };


    const handleDeleteClick = () => {
        // Show confirmation dialog


        const isConfirmed = window.confirm("Are you sure you want to delete this DC?");

        // // If user confirms, proceed with deletion
        if (isConfirmed) {
             dispatch(deleteDC(id))
                 .then(() => {
                     // Reload the page to show updated results
                     alert("DC Deleted");
                     window.location.reload();
                 })
                 .catch((error) => {
                     // Handle any errors that occur during the deletion process
                     console.error("Error deleting Item:", error);
                     toast.error("Failed to delete Item");
                 });
        }
    };
      const handlePendingClick = () => {
        window.open(`/packing-sale-invoice/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    const handleFinalPrint = () => {
        // window.open(`/packing-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    }

    const handleViewClick = () => {
        window.open(`/dc-bill/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
     const handleViewClick1 = () => {
        window.open(`/dc-scr-bill/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    

  


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {billNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {partyNm}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {total_amt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {net_amt}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
    <Button variant="contained" color="success" size="small" onClick={handleViewClick}>
        Mil To Party
    </Button>
</TableCell>
<TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
    <Button variant="contained" color="error" size="small" onClick={handleViewClick1}>
       Scr To Mil
    </Button>
</TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>*/}
                 <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
  {sts === '1' ? (
    <h4 style={{ color: 'blue', cursor: 'pointer' }} onClick={handleInvoiceBill}>
      Invoice Generated
    </h4>
  ) : (
    <h4 style={{ color: '#ff0000', cursor: 'pointer' }} onClick={handlePendingClick}>
      Pending
    </h4>
  )}
</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer`} onClick={handleDeleteClick} />
                </TableCell> 


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
